const url = 'https://cardley-api.herokuapp.com/';
// const url = 'http://localhost:5001/';
export default url;
